//
// 全てのアプリケーション起動時に必ず行われる初期化処理
//
import dayjs from 'dayjs'
import advancedFormat from 'dayjs/plugin/advancedFormat'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import isoWeek from 'dayjs/plugin/isoWeek'
import localeData from 'dayjs/plugin/localeData'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'
import weekday from 'dayjs/plugin/weekday'
import weekOfYear from 'dayjs/plugin/weekOfYear'
import weekYear from 'dayjs/plugin/weekYear'
import z from 'zod'
import { ja } from 'zod/locales'

if (process.env.NODE_ENV !== 'test') {
  // eslint-disable-next-line no-console
  console.log(`initializing application...`) // Node.jsの初期化周りの処理に自信がないので、しばらくログを出しておく
}

dayjs.extend(timezone)
dayjs.extend(utc)
dayjs.extend(isoWeek)
dayjs.tz.setDefault('Asia/Tokyo')
dayjs.extend(customParseFormat)
dayjs.extend(advancedFormat)
dayjs.extend(weekday)
dayjs.extend(localeData)
dayjs.extend(weekOfYear)
dayjs.extend(weekYear)

z.config(ja())
